<template>
  <div class="c-main-container">

    <div>
      <KidsList/>
    </div>

    <div class="promises-container">
      <div class="header-container">
        <span><img src="/images/icn_gift.svg"></span>
        <span class="contents">ご褒美・お約束</span>
        <span><img src="/images/icn_yubikiri.svg"></span>
      </div>
      <PromisesList :useEdit="true" @promiseSuccess="promiseSuccess"/>
    </div>

    <AdSense/>

    <div class="news-container">
      <div class="head"><i class="fal fa-info-circle"></i> お知らせ</div>
      <div class="contents">
        <UserNews :isHeadline="true"/>
      </div>
    </div>

    <div class="tACenter">
      <KidsAdd/>
    </div>
  </div>
</template>

<script>
import UserNews from '@/components/project/UserNews';
import KidsList from '@/components/project/KidsList';
import KidsAdd from '@/components/project/KidsAdd';
import PromisesList from '@/components/project/PromisesList';
import AdSense from '@/components/project/AdSense';

export default {
  components: {
    UserNews,
    KidsList,
    KidsAdd,
    PromisesList,
    AdSense
  },
  data () {
    return {
      lock: false,
      promise: {}
    };
  },
  watch: {
    lock: function () {

      // ローディング表示
      if (this.lock === true) {
        this.$store.dispatch('loading/open').then();
      } else {
        this.$store.dispatch('loading/close').then();
      }

    },
    callbackDispatcher: function () {
      console.log(this.callbackDispatcher);

      if (this.callbackDispatcher === 'AddAllPromiseSuccessPay') {
        this.promiseDrivenPay();
      } else if (this.callbackDispatcher === 'UseAllPromiseExecutePay') {
        this.promiseDrivenPay();
      }
    },
  },
  computed: {
    callbackDispatcher: function () {
      return this.$store.getters['message/callback'];
    },
  },
  methods: {
    promiseSuccess: function (promise) {
      console.log('promiseSuccess', promise);

      scrollTo(0, 0);

      this.promise = promise;

      let option;

      let kids = this.$store.getters['kids/list'];

      let text = '';

      if (promise.type === 1) {

        if (Object.keys(kids).length >= 2) {
          text = '全員に';
        }

        option = {
          is2Button: true,
          buttonLabelL: '全員に付与',
          buttonLabelR: 'キャンセル',
          isButtonOnly: false,
          callbackL: 'AddAllPromiseSuccessPay',
          messages: ['"' + promise.title + '"の' + promise.pay + 'ペイを' + text + '付与しますか？']
        };

      } else {

        if (Object.keys(kids).length >= 2) {
          text = '全員一律で';
        }

        option = {
          is2Button: true,
          buttonLabelL: '全員が利用',
          buttonLabelR: 'キャンセル',
          isButtonOnly: false,
          callbackL: 'UseAllPromiseExecutePay',
          messages: ['"' + promise.title + '"の' + promise.pay + 'ペイを' + text + '使いますか？']
        };
      }

      // 確認ダイアログ
      this.$store.dispatch('message/open', option).then();

    },
    promiseDrivenPay: function () {
      console.log('addPromiseSuccessPay', this.promise);

      if (this.lock === true) {
        // console.log('lock', this.lock);
        return;
      }

      let params = {
        pay: this.promise.pay,
        note: this.promise.title,
        s: this.$store.getters['auth/session']
      };
      // console.log(params);

      // ロック
      this.lock = true;

      let dispatch;

      if (this.promise.type === 1) {
        dispatch = 'pays/addAll';
      } else {
        dispatch = 'pays/useAll';
      }

      this.$store.dispatch(dispatch, params).then(() => {

        // ロック解除
        this.lock = false;

        let status = this.$store.getters['pays/status'];

        if (status === 200) {

          let option;
          if (this.promise.type === 1) {
            option = {
              is1Button: true,
              buttonLabel: '確認',
              callback: 'KidsListUpdate',
              callbackO: 'KidsListUpdate',
              messages: [this.promise.pay + 'ペイを付与しました']
            };
          } else {
            option = {
              is1Button: true,
              buttonLabel: '確認',
              callback: 'KidsListUpdate',
              callbackO: 'KidsListUpdate',
              messages: [this.promise.pay + 'ペイを付与しました']
            };
          }

          // 確認ダイアログ
          this.$store.dispatch('message/open', option).then();

        } else {
          // this.$store.dispatch('errorInfo/setErrorStore', 'pays').then();
          // this.$router.push({name: 'UserSystemError'});
        }

      }).catch((err) => {
        console.warn(err);

        // ロック解除
        this.lock = false;

        this.$store.dispatch('errorInfo/setSystemErrorMessage').then();
        this.$router.push({name: 'UserSystemError'});
      });
    }
  }
};

</script>

<style lang="scss" scoped>

  .header-container {
    display: flex;
    align-items: center;

    .contents {
      padding-left: 2px;
      padding-right: 2px;
    }
  }

  // 801以上
  @media screen and (min-width: 801px) {

    .news-container {
      margin-top: 30px;
      text-align: left;
      padding: 5px 20px;
      border: 1px solid #ddd;
      border-radius: 6px;

      .head {
        font-size: 16px;
      }
      .contents {
        margin: 10px;
        font-size: 14px;
      }
    }

    .promises-container {
      margin-top: 20px;
      margin-bottom: 10px;
      border: 1px solid #ddd;
      padding: 5px 5px 20px 10px;
      border-radius: 4px;
    }

  }

  // 800まで
  @media screen and (max-width: 800px) {

    .news-container {
      margin-top: 20px;
      text-align: left;
      padding: 5px 20px;
      border: 1px solid #ddd;
      border-radius: 6px;

      .head {
        font-size: 16px;
      }
      .contents {
        margin: 10px;
        font-size: 14px;
      }
    }

    .promises-container {
      margin-top: 20px;
      border: 1px solid #ddd;
      padding: 5px 5px 20px 10px;
      border-radius: 4px;
    }
  }

</style>
